<template>
  <div class="footer wow fadeInUp">
    <div class="rowFluid">
      <div class="span12">
        <div class="container">
          <div class="footer_content">
            <div class="span4 col-xm-6 col-xs-12">
              <div class="footer_list">
                <div class="footer_cotact">
                  <div class="footer_cotact_title">友情链接</div>
                  <ul class="frientLinks">
                    <!--<li><a href='http://www.guide-electric.com//' target='_blank'>武汉港迪电气集团有限公司</a></li>-->
                    <li><a href='http://www.gdetec.com//' target='_blank'>武汉港迪技术股份有限公司</a></li>
                    <li><a href='http://www.guide-zn.com//' target='_blank'>武汉港迪智能技术有限公司</a></li>
                  </ul>
                  <!--
                  <ul id="frientLinks">
                      <li><span class="footer_cotact_content">港迪电气有限公司</span></li>
                     <li><span class="footer_cotact_content">港迪传动有限公司</span></li>
                     <li><span class="footer_cotact_content">港迪软件有限公司</span></li>
                     </ul>
                     -->
                </div>
                <div style="margin-top: 20px">
                  <ul style="color: white"><a href="/#/legalStatement">法律声明</a></ul>
                </div>
              </div>
            </div>
            <!-- <div class="span4 col-xm-6 col-xs-12">
                <div class="footer_list">
                <div class="footer_cotact">
                    <div class="footer_cotact_title">友情链接</div>
                    <ul id="frientLinks">
                        <li><a href='http://www.guide-electric.com//' target='_blank'>武汉港迪电气集团有限公司</a></li>
                    </ul>
                </div>
                </div>
            </div> -->
            <div class="span4 col-xm-6 col-xs-12">
              <div class="footer_list">
                <div class="footer_cotact">
                  <div class="footer_cotact_title">联系方式</div>
                  <ul>
                    <li><span class="footer_cotact_type">地址：</span><span
                      class="footer_cotact_content">{{ companyAddress }}</span></li>
                    <li><span class="footer_cotact_type">电话：</span><span
                      class="footer_cotact_content">{{ phone }}</span></li>
                    <li><span class="footer_cotact_type">邮箱：</span><span
                      class="footer_cotact_content">{{ email }}</span></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="span4 col-xm-6 col-xs-12">
              <div class="footer_list">
                <div class="footer_cotact">
                  <div class="bottom_logo"><img :src="picData[0]" alt="微信服务号二维码"/></div>
                  <div class="bottom_logo_title">微信公众号</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="copyright">Copyright &copy; {{info}}</div>-->

    <div class="copyright">Copyright &copy; {{ info }}
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42018502005122"
         style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img
        src="../../assets/images/beian.png" style="float:left;"/>鄂公网安备 42018502005122号</a>
    </div>
  </div>
</template>
<script>
import {QueryBottom} from '../../api/News'

export default {
  data () {
    return {
      phone: '',
      companyAddress: '',
      email: '',
      info: '',
      picData: [
        require('../../assets/images/weixin.jpg')
      ]
    }
  },
  mounted () {
    this.GetData()
  },
  methods: {
    GetData () {
      QueryBottom().then((resp) => {
        this.phone = resp[0].phone
        this.companyAddress = resp[0].companyAddress
        this.email = resp[0].email
        this.info = resp[0].info
      })
    }

  }
}

</script>
<style lang="less" rel="stylesheet/less" scoped>

.rowFluid {
  padding: 30px 0;
  background: #0090dc;
}

.copyright {
  padding: 10px 0;
  background: #03486d;
}

.frientLinks li a {
  color: white;
}
</style>
/*
<ul>
<li><span class="footer_cotact_type">地址：</span><span
  class="footer_cotact_content">湖北省武汉市洪山区东湖高新技术开发区华师科技园光谷科技港2A栋</span></li>
<li><span class="footer_cotact_type">电话：</span><span class="footer_cotact_content">86-027-87925288</span></li>
<li><span class="footer_cotact_type">邮箱：</span><span class="footer_cotact_content">server@guide-soft.net</span></li>
</ul>*/



// WEBPACK FOOTER //
// src/components/footerBar/footerBar.vue